import { render, staticRenderFns } from "./Insatall.vue?vue&type=template&id=2ac16468&scoped=true"
import script from "./Insatall.vue?vue&type=script&lang=js"
export * from "./Insatall.vue?vue&type=script&lang=js"
import style0 from "./Insatall.vue?vue&type=style&index=0&id=2ac16468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac16468",
  null
  
)

export default component.exports